import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import { useHistory, useParams } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import {
    pagingQuestion,
    pagingAllQuestions,
    moreQuestion,
    getAnswers,
    setCommunityKey
} from "../../../store/actions/CommunityAction";
import ButtonBase from '../../Buttons/ButtonBase';
import { showLoading, hideLoading } from '../../../store/actions/LoadingActions';
import { Link as LinkScroll } from 'react-scroll';
import { Pagination } from '@material-ui/lab'
import { Avatar } from '@material-ui/core';
import moment from 'moment';
import "./listQuestion.scss";

const maleAvatar = '/img/avatars/avatares-cuadro-h.svg';
const femaleAvatar = '/img/avatars/avatares-cuadro-m.svg';
const lawFirmAvatar = '/img/avatars/avatares-cuadro-logo.svg';

const useStyles = makeStyles(theme => ({
    avatar: {
        cursor: 'pointer',
        width: 40,
        height: 40,
        marginRight: 8,
        backgroundColor: 'white'
    },
    avatarLetters: {
        backgroundColor: '#013957',
        color: 'white',
        fontSize: 18,
        cursor: 'pointer',
        width: 40,
        height: 40,
        marginRight: 8,
    },
    pagination: {
        display: 'flex',
        justifyContent: 'center',
    },
    linkStyle: {
        margin: 'auto 0',
        '@media screen and (max-width: 767.98px)': {
            margin: '10px 0 0 62px'
        },
        '@media screen and (max-width: 499.98px)': {
            margin: '10px 0 0'
        }
    },
    buttonStyle: {
        minWidth: 112,
        '@media screen and (max-width: 499.98px)': {
            minWidth: 'inherit',
            width: '100%',
            height: 40,
        }
    }
}));


const ListQuestionAndSearch = (props) => {
    const {
        listQuestion,
        pagingAllQuestions,
        type,
        moreAnsweredQuestion,
        inAnswers,
        topicInAnswers,
        pagingQuestion,
        moreQuestion,
        getAnswers,
        isLawyer,
        setCommunityKey,
    } = props
    const classes = useStyles();
    const history = useHistory();
    const params = useParams()

    const handleChangePage = async (event, value) => {
        try {
            if (inAnswers) {
                await pagingQuestion(topicInAnswers, value)
                setCommunityKey(topicInAnswers)
            } else {
                await pagingAllQuestions(value);
                setCommunityKey('')
            }
        } catch (error) {
            throw error;
        }
    };

    const handleNavigationQuestion = async (id) => {
        if (inAnswers) {
            try {
                await getAnswers(id, 1)
                await moreQuestion()
                history.push(`/comunidad/pregunta/${id}`)
            } catch (error) {
                throw error;
            }
        } else {
            history.push(`/comunidad/pregunta/${id}`)
        }
    }

    const [showQuestions, setShowQuestions] = useState([])

    useEffect(() => {
        if (inAnswers) {
            handleRelatedQuestions()
        }
        if (
            listQuestion &&
            listQuestion.data
        ) {
            let questions = listQuestion.data
            if (params.id && inAnswers) {
                questions = listQuestion.data.filter(elem => elem.id !== params.id)
            }
            setShowQuestions(questions)
        }
    }, [params.id, listQuestion])

    const handleRelatedQuestions = async () => {
        try {
            await pagingQuestion(topicInAnswers, 1)
            setCommunityKey(topicInAnswers)
        } catch (error) {
            console.log('error', error);
        }
    }

    const handleAllQuestions = () => {
        return (
            <>  
                {showQuestions &&
                showQuestions.length !== 0 &&
                !isLawyer ?
                    <div className="recentQuestionsContainer">
                        <p className={inAnswers ? "relatedQuestions" : "recentQuestions"}>
                            {inAnswers ?
                                'Preguntas relacionadas' :
                                'Preguntas recientes'
                            }
                        </p>
                    </div> : null
                }
                {showQuestions && showQuestions.length !== 0 && showQuestions.map((question, index) => {
                    let client = question.userClient;
                    const defaultAvatar =
                        client && client.role === 'lawyer'
                            ? client.genero === 'male'
                                ? maleAvatar
                                : femaleAvatar
                            : lawFirmAvatar;
                    let dateQuestion = moment.unix(question.createdAt).format('DD MMMM YYYY')
                    let dateResponse = question && question.lastReplyDate && moment.unix(question.lastReplyDate).format('DD MMMM YYYY')
                    return (
                        <div
                            key={index}
                            className="contentMainList"
                            onClick={() => handleNavigationQuestion(question.id)}
                        >
                            <div className="contentMainListContainer">
                                <div
                                    className={
                                        inAnswers ?
                                        "contentAvatarAnswers" :
                                        isLawyer ?
                                        "contentAvatarLawyer" :
                                        "contentAvatar"
                                    }
                                >
                                    {client && client.registeredSocial ?
                                        (<Avatar
                                            aria-haspopup="true"
                                            alt={client.displayName}
                                            className={classes.avatarLetters}
                                        />)
                                        :
                                        (<Avatar
                                            aria-haspopup="true"
                                            alt={client ? client.name + " " + client.lastName : 'avatar'}
                                            className={classes.avatarLetters}
                                        ></Avatar>)}
                                </div>
                                <div className="contentDataQuestion">
                                    <p className="titleQuestion">{question.title}</p>
                                    <p className="dateQuestion"> {dateQuestion}</p>
                                    <div className="contentTypes">
                                        <p className="dataType">{question.topic}</p>
                                        {/* <div className="lineSeparation2" />
                                        <p className="dataSubtype">
                                            {question.topic &&
                                            typeof question.topic === 'string' &&
                                            question.topic.length > 55 ?
                                                `${question.topic.slice(0, 55)}...` :
                                                question.topic ? question.topic :
                                                ''
                                            }
                                        </p> */}
                                    </div>
                                    {question.numberAnswers ?
                                        <div className="responseContainer">
                                            <p
                                                className="responseOne"
                                            >
                                                {inAnswers ?
                                                    <LinkScroll to="responseQuestion" smooth="true" duration={1500} offset={-60}>
                                                        <button>
                                                            {question.numberAnswers === 1 ?
                                                                'Ver 1 respuesta,' :
                                                                `Ver ${question.numberAnswers} respuestas,`
                                                            }
                                                        </button>
                                                        &nbsp;Última respuesta el {dateResponse}.
                                                    </LinkScroll> :
                                                    <>
                                                        <button>
                                                        {question.numberAnswers === 1 ?
                                                            'Ver 1 respuesta,' :
                                                            `Ver ${question.numberAnswers} respuestas,`
                                                        }
                                                        </button>
                                                        &nbsp;Última respuesta el {dateResponse}.
                                                    </>
                                                }
                                            </p>
                                        </div> : null
                                    }
                                </div>
                            </div>
                            {isLawyer &&
                                <ButtonBase
                                    type="button"
                                    variant="secondary"
                                    disabled={false}
                                    linkStyle={classes.linkStyle}
                                    buttonStyle={classes.buttonStyle}
                                >
                                    Responder
                                </ButtonBase>
                            }
                        </div>
                    )
                })}
                {listQuestion &&
                listQuestion.data &&
                listQuestion.data.length !== 0 ?
                    <Pagination
                        classes={{ root: classes.pagination }}
                        count={listQuestion.totalPages}
                        page={listQuestion.actualpage}
                        onChange={handleChangePage}
                        color="primary"
                    /> : null
                }
            </>
        )
    }

    const handlemostAnsweredAuestions = () => {
        return (
            <>
                {moreAnsweredQuestion &&
                moreAnsweredQuestion.length !== 0 ?
                    <div className="recentQuestionsContainer">
                        <p className="recentQuestions">Más respondidas</p>
                    </div> : null
                }
                
                {Object.entries(moreAnsweredQuestion).length > 0  && moreAnsweredQuestion.map((question, index) => {
                    let client = question.userClient;
                    let tag = client && client.displayName && client.displayName.split(1);
                    let dateQuestion = moment.unix(question.createdAt).format('DD MMMM YYYY')
                    let dateResponse = question && question.lastReplyDate && moment.unix(question.lastReplyDate).format('DD MMMM YYYY')
                    return (
                        <div
                            key={index}
                            className="contentMainList"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleNavigationQuestion(question.id)}
                        >
                            <div className="contentMainListContainer">
                                <div
                                    className={
                                        inAnswers ?
                                        "contentAvatarAnswers" :
                                        isLawyer ?
                                        "contentAvatarLawyer" :
                                        "contentAvatar"
                                    }
                                >
                                    {client && client.registeredSocial ?
                                        (<Avatar
                                            aria-haspopup="true"
                                            alt={client.displayName}
                                            className={classes.avatarLetters}
                                        />)
                                        :
                                        (<Avatar
                                            aria-haspopup="true"
                                            alt={client ? client.name + " " + client.lastName : 'avatar'}
                                            className={classes.avatarLetters}
                                        ></Avatar>)}
                                </div>
                                <div className="contentMostResponse">
                                    <p className="titleQuestion">{question.title}</p>
                                    <div className="contentTypes2">
                                        <p className="dataType2">{question.topic}</p>
                                        {/* <p className="dataSubtype2">
                                            {question.topic &&
                                            typeof question.topic === 'string' &&
                                            question.topic.length > 68 ?
                                                `${question.topic.slice(0, 68)}...` :
                                                question.topic ? question.topic :
                                                ''
                                            }
                                        </p> */}
                                    </div>
                                    <div className="contentDateAndResponse">
                                        <p className="dateQuestion2"> {dateQuestion}</p>
                                        <div className="lineSeparation" />
                                        <p className="dataResponse">
                                            {question.numberAnswers && question.numberAnswers === 1 ?
                                                '1 respuesta' :
                                            question.numberAnswers ?
                                                `${question.numberAnswers} respuestas` :
                                                '0 respuestas'
                                            }
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                })}

            </>
        )
    }

    return (
        <>
            {type === "list" ? handleAllQuestions() : moreAnsweredQuestion && handlemostAnsweredAuestions()}
        </>
    )

}

const mapDispatchToProps = dispatch => ({
    pagingQuestion: (search, page) => dispatch(pagingQuestion(search, page)),
    pagingAllQuestions: (page) => dispatch(pagingAllQuestions(page)),
    getAnswers: (id, page) => dispatch(getAnswers(id, page)),
    moreQuestion: () => dispatch(moreQuestion()),
    setCommunityKey: key => dispatch(setCommunityKey(key)),
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),
})

const mapStateToProps = (state) => ({
    laywerUid: state.authClient.uid,
    role: state.authClient.role,
    listQuestion: state.communityReducer.listQuestions,
    moreAnsweredQuestion: state.communityReducer.moreAnsweredQuestion,
});

export default connect(mapStateToProps, mapDispatchToProps)(ListQuestionAndSearch);